export enum BcmUserPermission {
    FULL_GRANT = 'bcm_full_grant',

    ASSETS_READ = 'bcm_assets_r',
    ASSETS_WRITE = 'bcm_assets_w',
    ASSETS_DELETE = 'bcm_assets_x',

    ASSET_EDITOR_READ = 'bcm_asset_editor_r',
    ASSET_EDITOR_WRITE = 'bcm_asset_editor_w',
    ASSET_EDITOR_DELETE = 'bcm_asset_editor_x',

    BERTHS_READ = 'bcm_berths_r',
    BERTHS_WRITE = 'bcm_berths_w',
    BERTHS_DELETE = 'bcm_berths_x',

    EXTERNAL_API_BERTHS_BOOKING = 'bcm_external_api_berths_booking',

    ABSENCES_READ = 'bcm_absences_r',
    ABSENCES_WRITE = 'bcm_absences_w',
    ABSENCES_DELETE= 'bcm_absences_x',

    // BERTHS_GRAPHICALLY_READ = 'bcm_berths_2d_r',
    // BERTHS_GRAPHICALLY_WRITE = 'bcm_berths_2d_w',

    WINTER_STORAGES_READ = 'bcm_winter_storages_r',
    WINTER_STORAGES_WRITE = 'bcm_winter_storages_w',
    WINTER_STORAGES_DELETE = 'bcm_winter_storages_x',

    BOATS_READ = 'bcm_boats_r',
    BOATS_WRITE = 'bcm_boats_w',
    BOATS_DELETE = 'bcm_boats_x',

    COMPANIES_READ = 'bcm_companies_r',
    COMPANIES_WRITE = 'bcm_companies_w',
    COMPANIES_DELETE = 'bcm_companies_x',

    DOCUMENTS_READ = 'bcm_documents_r',
    DOCUMENTS_WRITE = 'bcm_documents_w',
    DOCUMENTS_DELETE = 'bcm_documents_x',

    DOCUMENT_CATEGORIES_READ = 'bcm_document_categories_r',
    DOCUMENT_CATEGORIES_WRITE = 'bcm_document_categories_w',
    DOCUMENT_CATEGORIES_DELETE = 'bcm_document_categories_x',

    ELECTRIC_METERS_READ = 'bcm_electric_meters_r',
    ELECTRIC_METERS_WRITE = 'bcm_electric_meters_w',
    ELECTRIC_METERS_DELETE = 'bcm_electric_meters_x',

    INVOICES_READ = 'bcm_invoices_r',
    INVOICES_WRITE = 'bcm_invoices_w',
    INVOICES_DELETE = 'bcm_invoices_x',

    INVOICE_WD_TEMPLATES_READ = 'bcm_invoice_wd_templates_r',
    INVOICE_WD_TEMPLATES_WRITE = 'bcm_invoice_wd_templates_w',
    INVOICE_WD_TEMPLATES_DELETE = 'bcm_invoice_wd_templates_x',

    INVOICE_COLLECTIONS_READ = 'bcm_invoice_collections_r',
    INVOICE_COLLECTIONS_WRITE = 'bcm_invoice_collections_w',

    QUOTES_READ = 'bcm_quotes_r',
    QUOTES_WRITE = 'bcm_quotes_w',
    QUOTES_DELETE = 'bcm_quotes_x',

    INVOICE_EXPORT_DATEV = 'bcm_export_datev',
    INVOICE_EXPORT_XDOC = 'bcm_export_xdoc',
    INVOICE_EXPORT_SYSKA = 'bcm_export_syska',

    INVOICE_SEPA_RUNS_READ = 'bcm_sepa_runs_r',
    INVOICE_SEPA_RUNS_WRITE = 'bcm_sepa_runs_w',
    INVOICE_SEPA_RUNS_DELETE = 'bcm_sepa_runs_x',

    MAIL_READ = 'bcm_mail_r',
    MAIL_WRITE = 'bcm_mail_w',
    MAIL_DELETE = 'bcm_mail_x',

    MAIL_MAILINGS_READ = 'bcm_mail_mailings_r',
    MAIL_MAILINGS_WRITE = 'bcm_mail_mailings_w',
    MAIL_MAILINGS_DELETE = 'bcm_mail_mailings_x',

    MAIL_TEMPLATES_READ = 'bcm_mail_templates_r',
    MAIL_TEMPLATES_WRITE = 'bcm_mail_templates_w',
    MAIL_TEMPLATES_DELETE = 'bcm_mail_templates_x',

    MAIL_MESSAGES_READ = 'bcm_mail_messages_r',
    MAIL_MESSAGES_WRITE = 'bcm_mail_messages_w',
    MAIL_MESSAGES_DELETE = 'bcm_mail_messages_x',

    CONTRACTS_READ = 'bcm_contracts_r',
    CONTRACTS_WRITE = 'bcm_contracts_w',
    CONTRACTS_DELETE = 'bcm_contracts_x',

    PERSONS_READ = 'bcm_persons_r',
    PERSONS_WRITE = 'bcm_persons_w',
    PERSONS_DELETE = 'bcm_persons_x',

    PRODUCTS_READ = 'bcm_products_r',
    PRODUCTS_WRITE = 'bcm_products_w',
    PRODUCTS_DELETE = 'bcm_products_x',

    PRODUCT_CATEGORIES_READ = 'bcm_product_categories_r',
    PRODUCT_CATEGORIES_WRITE = 'bcm_product_categories_w',
    PRODUCT_CATEGORIES_DELETE = 'bcm_product_categories_x',

    // admin only
    // ROLES_AND_PERMISSIONS_READ = 'bcm_roles_and_permissions_r',
    // ROLES_AND_PERMISSIONS_WRITE = 'bcm_roles_and_permissions_w',
    // ROLES_AND_PERMISSIONS_DELETE = 'bcm_roles_and_permissions_x',

    /** @deprecated Verwende INVOICE_SEPA_RUNS_READ */
    SEPA_RUN_READ = 'bcm_sepa_runs_r',
    // SEPA_RUN_WRITE = 'bcm_sepa_runs_w',
    // SEPA_RUN_DELETE = 'bcm_sepa_runs_d',

    TENANT_RELATIONS_READ = 'bcm_tenant_relations_r',
    TENANT_RELATIONS_WRITE = 'bcm_tenant_relations_w',
    TENANT_RELATIONS_DELETE = 'bcm_tenant_relations_x',

    KEYS_READ = 'bcm_keys_r',
    KEYS_WRITE = 'bcm_keys_w',
    KEYS_DELETE = 'bcm_keys_x',

    SEASONS_READ = 'bcm_seasons_r',
    SEASONS_WRITE = 'bcm_seasons_w',
    SEASONS_DELETE = 'bcm_seasons_x',

    ORDERS_READ = 'bcm_jobs_r',
    ORDERS_WRITE = 'bcm_jobs_w',
    ORDERS_DELETE = 'bcm_jobs_x',

    AVV_SIGN = 'bcm_avv_sign',
    AVV_READ = 'bcm_avv_read',
    DOWNLOAD_REPORTS = 'bcm_download_reports',
    EXPORT_FILTERED_VIEW = 'bcm_export_filtered_view',
    ASSOCIATION_REPORTS = 'bcm_association_reports',

    // admin only (kein separater DB-Eintrag mehr – Prüfung über FULL_GRANT)
    // TENANT_DATA_READ = 'bcm_tenant_data_r',
    // TENANT_DATA_WRITE = 'bcm_tenant_data_w',

    // BANK_READ = 'bcm_banks_r',
    // BANK_WRITE = 'bcm_banks_w',
    // BANK_DELETE = 'bcm_banks_x',

    // IMPORTDATA_READ = 'bcm_importdata_r',

    DATABASE_DUMP_READ = 'bcm_database_dump_r',
    DATABASE_DUMP_WRITE = 'bcm_database_dump_w',

    CASH_REGISTER_READ = 'bcm_cash_registers_r',
    CASH_REGISTER_WRITE = 'bcm_cash_registers_w',
    CASH_REGISTER_DELETE = 'bcm_cash_registers_x',

    POS_RECEIPT_WRITE = 'bcm_pos_receipt_w',
    POS_INVOICE_WRITE = 'bcm_pos_invoice_w',
    POS_CREDITING_WRITE = 'bcm_pos_crediting_w',

    NEWS_READ = 'u2b_news_r',
    NEWS_WRITE = 'u2b_news_w',
    NEWS_DELETE = 'u2b_news_x',

    CASH_REGISTER_USERS_WRITE = 'bcm_cash_register_users_w',
    CASH_REGISTER_USERS_DELETE = 'bcm_cash_register_users_x',

    COST_CENTERS_READ = 'bcm_cost_centers_r',
    COST_CENTERS_WRITE = 'bcm_cost_centers_w',
    COST_CENTERS_DELETE = 'bcm_cost_centers_x',

    DEPARTMENTS_READ = 'bcm_departments_r',
    DEPARTMENTS_WRITE = 'bcm_departments_w',
    DEPARTMENTS_DELETE = 'bcm_departments_x',

    EMPLOYEES_READ = 'bcm_employees_r',
    EMPLOYEES_WRITE = 'bcm_employees_w',
    EMPLOYEES_DELETE = 'bcm_employees_x',

    WORKING_TIME_READ = 'bcm_working_time_r',
    WORKING_TIME_WRITE = 'bcm_working_time_w',
    WORKING_TIME_CORRECT = 'bcm_working_time_correct_w',
    WORKING_TIME_DELETE = 'bcm_working_time_x',

    BEER_MAT_EXPORT = 'beer_mat_export',
    PIN_CODES = 'pin_codes',

    HARBOUR_SETTINGS_READ = 'bcm_harbour_settings_r',

}
